import React from 'react';
import {CollapseFilter} from 'components/partials/collapse';

class ProductInfoCollapse extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <CollapseFilter value={false} title='Chi tiết sản phẩm'>
        <div className="content-detail" dangerouslySetInnerHTML={{__html: this.props.productContent}}></div>
      </CollapseFilter>
    );
  }
}

export default ProductInfoCollapse;



// WEBPACK FOOTER //
// ./components/partials/product/popup-view-detail/product-info-collapse/ProductInfoCollapse.jsx